<template>
  <v-card class="mx-auto" :disabled="loading">
    <v-card-title>
      <v-row>
        <v-col cols="12" md="8">
          <BtnCircle tLabel="Atrás" tPosition="bottom" icon="mdi-arrow-left" color="grey darken-3" size="x-small" :to="{
            name: 'contratantes.view',
            params: { id: $route.params.contractor_id },
          }" />

          <span class="text-h6 ml-1">
            {{ $route.meta.title }}
          </span>
          <br />
          <small>
            {{
              ` ${loading_contractor ? "" : `${contractor.name}`}${data.length == 0 ? "" : ` (${total_rows})`
              }`
            }}
          </small>
        </v-col>

        <v-col cols="12" md="4" class="text-right">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" fab x-small class="ml-1" color="info" :loading="faqs_ldg" :disabled="faqs.length == 0"
                @click.stop="faqs_dlg = true">
                <v-icon>mdi-help</v-icon>
              </v-btn>
            </template>
            <span v-text="'Ayuda'" />
          </v-tooltip>

          <v-tooltip v-if="
            login.permissions.insureds_xls &&
            login.permissions.insureds_xls.read
          " bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" fab x-small class="ml-1" color="teal" :loading="btn_xls_ldg" :disabled="data.length == 0"
                @click.prevent="downloadXls">
                <v-icon>mdi-table-arrow-down</v-icon>
              </v-btn>
            </template>
            <span v-text="'Descargar tabla XLS'" />
          </v-tooltip>

          <BtnCircle v-if="login.permissions.insureds_migration.create" tLabel="Migración" tPosition="bottom"
            icon="mdi-file-table" color="warning" size="x-small" :to="{
              name: 'asegurados.migracion',
              params: { contractor_id: $route.params.contractor_id },
            }" />

          <BtnCircle v-if="login.permissions.insureds_migration.create" tLabel="Recalcular" tPosition="bottom"
            icon="mdi-clipboard-account" color="pink darken-2" size="x-small" :to="{
              name: 'insureds.recalculate',
              params: { contractor_id: $route.params.contractor_id },
            }" />

          <BtnCircle v-if="login.permissions.insureds.create" tLabel="Crear" tPosition="bottom" icon="mdi-plus"
            color="success" size="x-small" :to="{ name: `${page_route}.store` }" />
        </v-col>
      </v-row>
    </v-card-title>

    <v-card-text>
      <v-row dense>
        <v-col cols="12" md="2">
          <v-select v-model="revision" label="Revisión" :items="revisions" item-value="id" :item-text="(v) => v.value"
            dense @change="getTableData" />
        </v-col>

        <v-col v-if="revision != null" cols="12" md="2">
          <v-select v-model="medical_treatment" label="Acompañamiento méd." :items="medical_treatments" item-value="id"
            :item-text="(v) => v.value" dense @change="getTableData" />
        </v-col>

        <v-col v-if="data.length > 0" cols="12" md="8">
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar..." single-line hide-details dense />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-data-table :headers="headers" :items="data" :search="search" :loading="loading" :items-per-page="15">
            <template v-slot:item.index="{ index }">
              {{ index + 1 }}
            </template>

            <template v-slot:item.has_special_conditions="{ item }">
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" :color="item.has_special_conditions ? 'orange' : 'grey'
                    ">
                    {{ item.has_special_conditions ? "mdi-star" : "mdi-minus" }}
                  </v-icon>
                </template>
                <span>
                  {{
                    item.has_special_conditions
                      ? "Con condiciones especiales"
                      : "Sin condiciones especiales"
                  }}
                </span>
              </v-tooltip>
            </template>

            <template v-slot:item.self_insurance_excess="{ item }">
              <v-chip x-small :color="item.self_insurance_excess ? 'orange' : 'grey'" dark>
                {{ item.insured_icds_count }}
              </v-chip>
            </template>

            <template v-slot:item.medical_treatment="{ item }">
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small :color="(item.medical_treatment ? 'pink ' : 'grey') + ' darken-1'
                    ">
                    mdi-shield-account
                  </v-icon>
                </template>
                <span v-text="(item.medical_treatment ? 'Con' : 'Sin') +
                  ' Acompañamiento méd.'
                  " />
              </v-tooltip>
            </template>

            <template v-slot:item.user_id="{ item }">
              <v-icon small :color="item.user_id ? 'success' : ''" v-text="item.user_id ? 'mdi-check' : 'mdi-close'" />
            </template>

            <template v-slot:item.revision_pending.revision_user="{ item }">
              <div v-if="item.revision_pending" class="text-center">
                <v-icon small :color="item.revision_pending.revision == null
                  ? 'warning'
                  : item.revision_pending.revision &&
                    item.revision_pending.accepted
                    ? 'success'
                    : 'error'
                  ">
                  mdi-{{
                    item.revision_pending.revision == null
                      ? "alert"
                      : item.revision_pending.revision &&
                        item.revision_pending.accepted
                        ? "check"
                        : "close"
                  }}
                </v-icon>

                <div v-if="item.revision_pending.revision">
                  <span v-text="item.revision_pending.revision_user" />
                  <br />
                  <small v-text="item.revision_pending.revision_date" />
                </div>
              </div>

              <v-icon v-else small>mdi-alert</v-icon>
            </template>

            <template v-slot:item.revision_pending.confirmation_user="{ item }">
              <div v-if="item.revision_pending" class="text-center">
                <v-icon small :color="item.revision_pending.confirmation == null
                  ? 'warning'
                  : item.revision_pending.confirmation &&
                    item.revision_pending.accepted
                    ? 'success'
                    : 'error'
                  ">
                  mdi-{{
                    item.revision_pending.confirmation == null
                      ? "alert"
                      : item.revision_pending.confirmation &&
                        item.revision_pending.accepted
                        ? "check"
                        : "close"
                  }}
                </v-icon>

                <div v-if="item.revision_pending.confirmation">
                  <span v-text="item.revision_pending.confirmation_user" />
                  <br />
                  <small v-text="item.revision_pending.confirmation_date" />
                </div>
              </div>

              <v-icon v-else small>mdi-alert</v-icon>
            </template>

            <template v-slot:item.action="{ item }">
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" fab x-small color="primary" :to="{
                    name: `${page_route}.view`,
                    params: { id: item.id },
                  }">
                    <v-icon v-text="'mdi-eye-outline'" />
                  </v-btn>
                </template>
                <span v-text="'Ver'" />
              </v-tooltip>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card-text>

    <FaqDlg v-model="faqs_dlg" :faqs="faqs" />
  </v-card>
</template>

<script>
import Axios from "axios";

import {
  URL_API,
  headersToken,
  base64ToArrayBuffer,
  dateTimeToFile,
  msgAlert,
} from "../../control";

import { index, show } from "../../requests/pageRequest";

import BtnCircle from "../../components/BtnCircle.vue";
import FaqDlg from "../../components/FaqDlg.vue";

export default {
  components: {
    BtnCircle,
    FaqDlg,
  },

  data() {
    return {
      contractor_id: this.$route.params.contractor_id,
      page_route: "asegurados",
      login: this.$store.getters.getLogin,

      loading: false,
      data: [],
      total_rows: 0,
      search: "",

      contractor: {},
      loading_contractor: true,

      headers: [
        {
          text: "#",
          filterable: false,
          value: "index",
        },
        {
          text: "ID SM|Asegurado",
          filterable: true,
          value: "enrollment",
        },
        {
          text: "Nombre",
          filterable: true,
          value: "name",
        },
        {
          text: "A. paterno",
          filterable: true,
          value: "first_surname",
        },
        {
          text: "A. materno",
          filterable: true,
          value: "second_surname",
        },
        {
          text: "F. Nacimiento",
          filterable: true,
          value: "birthday",
        },
        {
          text: "Póliza",
          filterable: true,
          value: "policy",
        },
        {
          text: "Vigencia",
          filterable: true,
          value: "validity",
        },
        {
          text: "Cond. especiales",
          value: "has_special_conditions",
          align: "center",
        },
        {
          text: "Exceso de autoseguro",
          value: "self_insurance_excess",
          align: "center",
        },
        {
          text: "T. méd.",
          value: "medical_treatment",
          align: "center",
          width: "80",
        },
        {
          text: "Usr. sis.",
          filterable: false,
          value: "user_id",
          align: "center",
          width: "80",
        },
        {
          text: "Tipo",
          filterable: true,
          value: "insured_type.insured_type",
        },
        {
          text: "R1",
          filterable: true,
          value: "revision_pending.revision_user",
          align: "center",
        },
        {
          text: "R2",
          filterable: true,
          value: "revision_pending.confirmation_user",
          align: "center",
        },
        {
          text: "",
          value: "action",
          sortable: false,
          width: "60",
        },
      ],

      revision: 0,
      revisions: [
        { id: null, value: "Selecciona una opción..." },
        { id: 0, value: "NO APLICA" },
        { id: 1, value: "REEMBOLSO" },
        { id: 2, value: "DATOS BANCARIOS | NO REG. PARA REEMBOLSO" },
        { id: 3, value: "DATOS BANCARIOS | REV 1 PENDIENTE" },
        { id: 4, value: "DATOS BANCARIOS | REV 2 PENDIENTE" },
        { id: 5, value: "DATOS BANCARIOS | REV. VALIDADA" },
        { id: 6, value: "DATOS BANCARIOS | REV. RECHAZADA" },
      ],

      medical_treatment: 0,
      medical_treatments: [
        { id: 0, value: "TODOS" },
        { id: 1, value: "En Acompañamiento méd." },
        { id: 2, value: "Sin Acompañamiento méd." },
      ],

      btn_xls_ldg: false,

      faqs: [],
      faqs_dlg: false,
      faqs_ldg: true,
    };
  },

  methods: {
    async getTableData() {
      this.data = [];
      this.total_rows = 0;

      if (this.revision == null) {
        return;
      }

      this.loading = true;

      try {
        const response = await index(
          "insureds/contractor/" + this.contractor_id,
          this.login.token,
          [
            {
              name: "medical_treatment",
              value: this.medical_treatment,
            },
            {
              name: "revision",
              value: this.revision,
            },
          ],
        );

        this.data = response.data || [];
        this.total_rows = this.data.length;
      } catch (err) {
        this.$swal.fire(
          msgAlert("error", "No fue posible cargar los asegurados"),
        );
      } finally {
        this.loading = false;
      }
    },

    async getContractor() {
      this.loading_contractor = true;

      try {
        this.contractor = await show(
          "contractors",
          this.login.token,
          this.contractor_id,
        );
      } catch (err) {
        this.$swal.fire(
          msgAlert("error", "No fue posible cargar el contratante"),
        );
      } finally {
        this.loading_contractor = false;
      }
    },

    async getFaqs() {
      this.faqs = [];
      this.faqs_ldg = true;

      try {
        const resp = await Axios.get(
          URL_API + "/faqs/faq_interfaces/" + this.$route.meta.title,
          headersToken(this.login.token),
        );

        this.faqs = resp.data.data || [];
      } catch (err) {
        this.faqs = [];
      } finally {
        this.faqs_ldg = false;
      }
    },

    async downloadXls() {
      this.btn_xls_ldg = true;

      try {
        const res = await Axios.post(
          URL_API + "/insureds/xls",
          {
            items: this.data,
          },
          headersToken(this.login.token),
        );

        if (!res.data.success) {
          this.$swal.fire(msgAlert("error", "Error al generar archivo XLSX"));
          return;
        }

        this.fileDownload(res.data.data, "xlsx", "asegurados");
      } catch (err) {
        this.$swal.fire(msgAlert("error", "Error al generar archivo XLSX"));
      } finally {
        this.btn_xls_ldg = false;
      }
    },

    fileDownload(base64, ext, name) {
      const blob = new Blob([base64ToArrayBuffer(base64)], {
        type: "application/" + ext,
      });

      const downloadLink = document.createElement("a");
      const url = URL.createObjectURL(blob);

      downloadLink.setAttribute("target", "_blank");
      downloadLink.href = url;
      downloadLink.download = "SM_" + name + "_" + dateTimeToFile() + "." + ext;
      downloadLink.click();

      URL.revokeObjectURL(url);
    },
  },

  mounted() {
    this.getFaqs();
    this.getContractor();
    this.getTableData();
  },
};
</script>
